module.exports = __webpack_public_path__ + "31ff7914c1b03cbbf35eed081ee7afc4.jpg";